import { Link, useLocation } from "@tanstack/react-router";
import { forwardRef, type ForwardedRef, type ReactNode } from "react";
import { SidebarMenuButton, useSidebar } from "ui";
import { cn, type ButtonProps } from "ui";

interface RouteMatch {
  pathname: string;
}

export interface NavButtonProps {
  icon: ReactNode;
  text: string;
  href: string;
  suffix?: ReactNode;
  className?: string;
  variant?: ButtonProps["variant"];
  size?: ButtonProps["size"];
  activeWhen?: (match: RouteMatch) => boolean;
}

export const NavButtonV2 = forwardRef(function NavButtonV2(
  { href, activeWhen, className, ...props }: NavButtonProps,
  ref: ForwardedRef<HTMLAnchorElement>,
) {
  const sidebar = useSidebar();
  const pathname = useLocation({
    select: (loc) => loc.pathname,
  });
  const isActive = activeWhen ? activeWhen({ pathname }) : false;

  return (
    <SidebarMenuButton asChild isActive={isActive}>
      <Link
        to={href}
        ref={ref}
        onClick={() => {
          sidebar.setOpenMobile(false);
        }}
        className={cn(className, {
          active: isActive,
        })}
        activeProps={{
          className: "active",
        }}
      >
        {props.icon}
        <span className="">{props.text}</span>
        {props.suffix}
      </Link>
    </SidebarMenuButton>
  );
});
